import { Record } from 'immutable';

export interface SortInterface {
  sortBy: string | undefined;
  order: string | undefined;
}

export const initialState: SortInterface = {
  sortBy: undefined,
  order: undefined
};

export default class SortState extends Record(initialState) { }
